import uniq from 'lodash.uniq';

import { ProjectModelClass } from 'src/store/state/projects';
import { ModelClassBindingResult } from 'src/templates/queries/modelClasses';

export const parseModelClassResults = (results: ModelClassBindingResult[]) =>
  results.reduce<Record<string, ProjectModelClass>>((acc, result) => {
    const iri = result.subject?.value;
    if (!iri) {
      return acc;
    }

    if (!acc[iri]) {
      acc[iri] = {
        iri,
        parents: [],
      };
    }

    const parent = result.parent?.value;
    if (parent) {
      acc[iri].parents = uniq([...acc[iri].parents, parent]);
    }

    return acc;
  }, {});
